import { render } from "./Suspend.vue?vue&type=template&id=67f35426"
import script from "./Suspend.vue?vue&type=script&lang=js"
export * from "./Suspend.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/touran-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__